import React from "react";
import { DocumentMyDeskResponse } from "apis/data-contracts";
import styled from "styled-components";

interface DocumentStatusProps {
  status: DocumentMyDeskResponse["status"];
}

const STATUS_INFO: Record<DocumentMyDeskResponse["status"], { label: string }> =
  {
    TEMP: {
      label: "임시저장",
    },
    APPROVE_IN_PROGRESS: { label: "결재대기" },
    REQ_SUPPLEMENT: { label: "보완요청" },
    APPROVE: { label: "결재완료" },
    REVIEW_IN_PROGRESS: { label: "검토중" },
    REVIEW: { label: "검토완료" },
  };

const DocumentStatus = ({ status, ...rest }: DocumentStatusProps) => {
  const currentStatus = STATUS_INFO[status];
  return (
    <WrapStyle {...rest} status={status}>
      {currentStatus?.label}
    </WrapStyle>
  );
};

export default DocumentStatus;

/* 스타일 */

export const WrapStyle = styled.div<{
  status: DocumentMyDeskResponse["status"];
}>`
  color: ${({ status, theme }) =>
    (function (status) {
      if (
        status === "APPROVE_IN_PROGRESS" ||
        status === "REVIEW_IN_PROGRESS" ||
        status === "REQ_SUPPLEMENT"
      ) {
        return theme.color.text.danger;
      }

      return theme.color.text.default;
    })(status)};
`;
